import React, { FC, lazy } from 'react'
import 'react-calendar/dist/Calendar.css'
import 'react-datetime-picker/dist/DateTimePicker.css'
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom'
import './main.scss'
import { PageAuthLogin } from './pages/auth'
import { AppShell } from './pages/wraper'

const PageDashboard = lazy(() =>
  import(/* webpackPrefetch: true */ './pages/dashboard').then((m) => ({ default: m.PageDashboard })),
)
const UserList = lazy(() =>
  import(/* webpackPrefetch: true */ './pages/user').then((m) => ({ default: m.UserList })),
)
const UserDetails = lazy(() =>
  import(/* webpackPrefetch: true */ './pages/user/user/UserDetails').then((m) => ({ default: m.UserDetails })),
)
const UserOnline = lazy(() =>
  import(/* webpackPrefetch: true */ './pages/user/user-online').then((m) => ({ default: m.UserOnline })),
)
const UserAddress = lazy(() =>
  import(/* webpackPrefetch: true */ './pages/user/user-address').then((m) => ({ default: m.UserAddress })),
)
const PageFranchiseTable = lazy(() =>
  import(/* webpackPrefetch: true */ './pages/franchise/table').then((m) => ({ default: m.PageFranchiseTable })),
)
const PageFranchiseTree = lazy(() =>
  import(/* webpackPrefetch: true */ './pages/franchise/tree').then((m) => ({ default: m.PageFranchiseTree })),
)
const PageFranchiseLevelSettingHistory = lazy(() =>
  import(/* webpackPrefetch: true */ './pages/franchise/level-setting-history').then((m) => ({
    default: m.PageFranchiseLevelSettingHistory,
  })),
)
const PageFranchiseCommissionHistory = lazy(
  () => import(/* webpackPrefetch: true */ './pages/franchise/commission'),
)
const UserDetail = lazy(() =>
  import(/* webpackPrefetch: true */ './pages/user/user/UserDetail').then((m) => ({ default: m.UserDetail })),
)
const TransactionList = lazy(() =>
  import(/* webpackPrefetch: true */ './pages/transaction/transaction/TransactionList').then((m) => ({
    default: m.TransactionList,
  })),
)
const WithdrawProgress = lazy(() =>
  import(/* webpackPrefetch: true */ './pages/transaction/withdraw/WithdrawProgress').then((m) => ({
    default: m.WithdrawProgress,
  })),
)
const ReportSystem = lazy(() =>
  import(/* webpackPrefetch: true */ './pages/report/system').then((m) => ({ default: m.ReportSystem })),
)
const MaintenanceConfig = lazy(() =>
  import(/* webpackPrefetch: true */ './pages/config/maintenance/maintenanceConfig').then((m) => ({
    default: m.MaintenanceConfig,
  })),
)
const NewsPage = lazy(() => import(/* webpackPrefetch: true */ './pages/config/news'))
const CreateNewsPage = lazy(() =>
  import(/* webpackPrefetch: true */ './pages/config/news/createNews').then((m) => ({ default: m.CreateNewsPage })),
)
const EditNewsPage = lazy(() =>
  import(/* webpackPrefetch: true */ './pages/config/news/editNews').then((m) => ({ default: m.EditNewsPage })),
)
const ProfitInvest = lazy(() => import(/* webpackPrefetch: true */ './pages/profit-invest'))
const InvestHistory = lazy(() =>
  import(/* webpackPrefetch: true */ './pages/invest/history').then((m) => ({ default: m.InvestHistory })),
)
const InvestmentWithdrawals = lazy(() =>
  import(/* webpackPrefetch: true */ './pages/invest/investment-withdrawals').then((m) => ({
    default: m.InvestmentWithdrawals,
  })),
)
const RwaEntitlement = lazy(() =>
  import(/* webpackPrefetch: true */ './pages/rwa-entitlement').then((m) => ({ default: m.RwaEntitlement })),
)
const PageDirectCommissionHistory = lazy(
  () => import(/* webpackPrefetch: true */ './pages/commission/direct'),
)
const PageSunlineSameRankCommissionHistory = lazy(
  () => import(/* webpackPrefetch: true */ './pages/commission/sunline-samerank'),
)
const PageUserRankTrackingHistory = lazy(
  () => import(/* webpackPrefetch: true */ './pages/commission/rank-tracking'),
)
const PageSetRankHistory = lazy(() => import(/* webpackPrefetch: true */ './pages/commission/set-rank'))

// Unused route targets kept as comments for easy restore:
// const PageClaimList = lazy(() => import('./pages/claim').then((m) => ({ default: m.PageClaimList })))
// const Activities = lazy(() => import('./pages/config/activities'))
// const ChangePassword = lazy(() => import('./pages/config/change-password'))
// const WithdrawConfig = lazy(() => import('./pages/config/withdraw/withdrawConfig').then((m) => ({ default: m.WithdrawConfig })))
// const PageDashboardSuperAdmin = lazy(() => import('./pages/dashboard-super-admin').then((m) => ({ default: m.PageDashboardSuperAdmin })))
// const PageExperienceGameList = lazy(() => import('./pages/experience-game').then((m) => ({ default: m.PageExperienceGameList })))
// const PageFranchiseLeaderTable = lazy(() => import('./pages/franchise/leaderTable').then((m) => ({ default: m.PageFranchiseLeaderTable })))
// const GameCreatePage = lazy(() => import('./pages/game-management').then((m) => ({ default: m.GameCreatePage })))
// const GameEditPage = lazy(() => import('./pages/game-management').then((m) => ({ default: m.GameEditPage })))
// const GameListPage = lazy(() => import('./pages/game-management').then((m) => ({ default: m.GameListPage })))
// const OrdersPage = lazy(() => import('./pages/game-management').then((m) => ({ default: m.OrdersPage })))
// const SupplierListPage = lazy(() => import('./pages/game-management').then((m) => ({ default: m.SupplierListPage })))
// const SupplierCreatePage = lazy(() => import('./pages/game-management/suppliers/add').then((m) => ({ default: m.SupplierCreatePage })))
// const SupplierEditPage = lazy(() => import('./pages/game-management/suppliers/edit').then((m) => ({ default: m.SupplierEditPage })))
// const PageGameOrdersList = lazy(() => import('./pages/game-orders').then((m) => ({ default: m.PageGameOrdersList })))
// const AirdropPage = lazy(() => import('./pages/transaction/airdrop').then((m) => ({ default: m.AirdropPage })))
// const DepositSupport = lazy(() => import('./pages/transaction/deposit-support/DepositSupport').then((m) => ({ default: m.DepositSupport })))
// const TransactionDemoList = lazy(() => import('./pages/transaction/transaction/TransactionDemoList').then((m) => ({ default: m.TransactionDemoList })))
// const TransactionAdminWithdrawList = lazy(() => import('./pages/transaction/withdraw-to-admin-wallet/TransactionAdminWithdrawList').then((m) => ({ default: m.TransactionAdminWithdrawList })))
// const PageUserAffiliation = lazy(() => import('./pages/user/affiliation').then((m) => ({ default: m.PageUserAffiliation })))
// const PageKYC = lazy(() => import('./pages/user/kyc').then((m) => ({ default: m.PageKYC })))
// const PageUserKYCList = lazy(() => import('./pages/user/kyc/KYCList').then((m) => ({ default: m.PageUserKYCList })))
// const DepositFiat = lazy(() => import('./pages/fiat/deposit').then((m) => ({ default: m.DepositFiat })))
// const WithdrawFiat = lazy(() => import('./pages/fiat/withdraw').then((m) => ({ default: m.WithdrawFiat })))
// const UserPromotion = lazy(() => import('./pages/user/promotion').then((m) => ({ default: m.UserPromotion })))
// const UserWithdrawLimit = lazy(() => import('./pages/config/user-withdraw-limit'))
// const UserBuyPrivateSale = lazy(() => import('./pages/user/private-sale').then((m) => ({ default: m.UserBuyPrivateSale })))
const UserInfomation = lazy(() =>
  import(/* webpackPrefetch: true */ './pages/user/user-infomation').then((m) => ({ default: m.UserInfomation })),
)
// const RolePermission = lazy(() => import('./pages/config/role-permission'))

export const Routes = {
  // dashboard: {
  //     path: '/',
  //     component: PageDashboard,
  // },
  dashboard: {
    path: '/',
    component: PageDashboard,
  },
  dashboardSuperAdmin: {
    path: '/page-dashboard-super-admin',
    // component: PageDashboardSuperAdmin,
    component: UserList,
  },
  userList: {
    path: '/user-list',
    component: UserList,
  },
  userDetails: {
    path: '/user-details',
    component: UserDetails,
  },
  userInfomation: {
    path: '/user-infomation',
    component: UserInfomation,
  },
  userOnline: {
    path: '/user-online',
    component: UserOnline,
  },
  // userBuyPrivateSale: {
  //   path: "/user-buy-private-sale",
  //   component: UserBuyPrivateSale,
  // },
  userPromotion: {
    path: '/user-promotion',
    // component: UserPromotion,
    component: UserList,
  },
  userKYCList: {
    path: '/kyc-list',
    // component: PageUserKYCList,
    component: UserList,
  },
  userAffiliation: {
    path: '/user-affiliation',
    // component: PageUserAffiliation,
    component: UserList,
  },
  userAddress: {
    path: '/user-address',
    component: UserAddress,
  },
  franchiseTable: {
    path: '/franchise-table',
    component: PageFranchiseTable,
  },
  franchiseTree: {
    path: '/franchise-tree',
    component: PageFranchiseTree,
  },
  franchiseLevelSettingHistory: {
    path: '/franchise-level-setting-history',
    component: PageFranchiseLevelSettingHistory,
  },
  franchiseCommissionHistory: {
    path: '/franchise-commission-history',
    component: PageFranchiseCommissionHistory,
  },
  franchiseLeader: {
    path: '/franchise-leader',
    // component: PageFranchiseLeaderTable,
    component: UserList,
  },
  // privateSale: {
  //   path: "/private-sale",
  //   component: UserBuyPrivateSale,
  // },
  userDetail: {
    path: '/user-list/:email',
    component: UserDetail,
    renderPath: (email: string) => `/user-list/${email}`,
  },
  transactionList: {
    path: '/transaction-list',
    component: TransactionList,
  },
  transactionDemoList: {
    path: '/transactions-demo',
    // component: TransactionDemoList,
    component: UserList,
  },
  withdraw: {
    path: '/transactions-withdraws',
    component: WithdrawProgress,
    // component: UserList,
  },
  AirdropPage: {
    path: '/transactions-airdrop',
    // component: AirdropPage,
    component: UserList,
  },
  kyc: {
    path: '/kyc',
    // component: PageKYC,
    component: UserList,
  },
  reportSystem: {
    path: '/system-report',
    component: ReportSystem,
  },
  depositSupport: {
    path: '/transactions-deposit-support',
    // component: DepositSupport,
    component: UserList,
  },
  TransactionAdminWithdrawList: {
    path: '/transactions-withdraw-to-admin-wallet',
    // component: TransactionAdminWithdrawList,
    component: UserList,
  },
  withdrawConfig: {
    path: '/server-config-withdraw',
    // component: WithdrawConfig,
    component: UserList,
  },
  maintenanceConfig: {
    path: '/server-config-maintenance',
    component: MaintenanceConfig,
  },
  rolePermission: {
    path: '/server-config-role-permission',
    // component: RolePermission,
    component: UserList,
  },
  changePassword: {
    path: '/server-config-change-password',
    // component: ChangePassword,
    component: UserList,
  },
  activities: {
    path: '/server-config-activities',
    // component: Activities,
    component: UserList,
  },
  // ClaimList: {
  //   path: "/claim-list",
  //   component: PageClaimList,
  // },
  GameOrdersList: {
    path: '/game-orders-list',
    // component: PageGameOrdersList,
    component: UserList,
  },
  OrdersPage: {
    path: '/game-management-orders',
    // component: OrdersPage,
    component: UserList,
  },
  SupplierListPage: {
    path: '/game-management-supplier',
    // component: SupplierListPage,
    component: UserList,
  },
  SupplierCreatePage: {
    path: '/game-management-supplier/create',
    // component: SupplierCreatePage,
    component: UserList,
  },
  SupplierEditPage: {
    path: '/game-management-supplier/edit/:id',
    // component: SupplierEditPage,
    component: UserList,
  },
  GameListPage: {
    path: '/game-management-game',
    // component: GameListPage,
    component: UserList,
  },
  GameCreatePage: {
    path: '/game-management-game/create',
    // component: GameCreatePage,
    component: UserList,
  },
  GameEditPage: {
    path: '/game-management-game/edit/:id',
    // component: GameEditPage,
    component: UserList,
  },
  // ExperienceGameList: {
  //   path: "/experience-game-list",
  //   component: PageExperienceGameList,
  // },
  News: {
    path: '/server-config/news',
    component: NewsPage,
  },
  CreateNews: {
    path: '/server-config/news/create',
    component: CreateNewsPage,
  },
  EditNews: {
    path: '/server-config/news/edit',
    component: EditNewsPage,
  },
  DepositFiat: {
    path: '/fiat/deposit',
    // component: DepositFiat,
    component: UserList,
  },
  WithdrawFiat: {
    path: '/fiat/withdraw',
    // component: WithdrawFiat,
    component: UserList,
  },
  UserWithdrawLimit: {
    path: '/server-config/user-withdraw-limit',
    // component: UserWithdrawLimit,
    component: UserList,
  },

  profitInvest: {
    path: '/profit-invest',
    component: ProfitInvest,
  },
  investHistory: {
    path: '/invest-history',
    component: InvestHistory,
  },
  investWithdrawals: {
    path: '/invest-withdrawals',
    component: InvestmentWithdrawals,
  },
  rwaEntitlement: {
    path: '/rwa-entitlement',
    component: RwaEntitlement,
  },
  commissionDirect: {
    path: '/commission/direct',
    component: PageDirectCommissionHistory,
  },
  commissionSunlineAndSameRank: {
    path: '/commission/sunline-samerank',
    component: PageSunlineSameRankCommissionHistory,
  },
  commissionRankTracking: {
    path: '/commission/rank-tracking',
    component: PageUserRankTrackingHistory,
  },
  commissionSetRank: {
    path: '/commission/set-rank',
    component: PageSetRankHistory,
  },
}

export const AppRoutes: FC = () => {
  return (
    <Router>
      <Switch>
        <Route path='/authentication/login' component={PageAuthLogin} />
        <Route component={AppShell} />
      </Switch>
    </Router>
  )
}
